import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "operation-wrapper" }

import { onMounted, reactive, ref } from 'vue'
import { onBeforeRouteLeave } from 'vue-router'
import dayjs from 'dayjs'
import { FormType, OpenStatus, RouterName } from '@/enum'
import utc from 'dayjs/plugin/utc'
import OpenAccount from './components/openAccount.vue'
import { useQuery } from '@vue/apollo-composable'
import { draftsCustomeOpenStatus } from '@/graphql/query'
import { SetpList } from '../guide/index.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

dayjs.extend(utc)

onBeforeRouteLeave(to => {
  const { name } = to
  if (name === RouterName.TRANSFER_PRO) {
    return false
  }
  return true
})
const imgUrl = ref(require('@/assets/images/quick@2x.png'))

const btnInfo = reactive({
  draftsAccount: {
    step: 0,
    openStatus: 0,
    remark: 'string'
  },
  draftsImmigrantAccount: {
    step: 0,
    openStatus: 0,
    remark: 'string'
  },
  accountBtnInfo: {
    text: '开通普通账户',
    btnText: '立即开户',
    btnTips: '',
    bgImagesUrl: '',
    iconImagesUrl: '',
    routerName: '',
    customStatus: 0
  },
  immigrantBtnInfo: {
    text: '开通投资移民账户',
    btnText: '立即开户',
    btnTips: '',
    bgImagesUrl: '',
    iconImagesUrl: '',
    routerName: '',
    customStatus: 0
  }
})

const { onResult } = useQuery(draftsCustomeOpenStatus, {
  filter: {
    meta: 'open_common'
  },
  param: {
    openAccountType: 1
  },
  paramImmigrant: {
    openAccountType: 9
  }
})

const stepList: SetpList = {
  1: RouterName.ID_CARD,
  2: RouterName.ID_CARD_INFO,
  3: RouterName.CONTACT_INFO,
  4: RouterName.FINANCIAL_INFO,
  5: RouterName.TAX_INFO,
  6: RouterName.RISK,
  7: RouterName.OTHER,
  8: RouterName.PI,
  9: RouterName.PI_RISK,
  10: RouterName.PI_AR,
  11: RouterName.STATEMENT,
  12: RouterName.CAPTCHA,
  13: RouterName.CONFIRM,
  14: RouterName.TRANSFER_STEP,
  15: RouterName.BIND_CARD,
  16: RouterName.TRANSFER,
  17: RouterName.TRANSFER_PRO,
  18: RouterName.ACCOUNT_TYPE
}

const fromartDoc = (applicationStatus: number, accountType: string) => {
  let btnText = ''
  let btnTips = ''
  let customStatus = 0
  let bgImagesUrl = ''
  let routerName = ''
  switch (applicationStatus) {
    case OpenStatus.REVIEW:
      btnText = '审核中'
      btnTips = '预计在3个工作日内完成'
      // setApptitle('提交成功')
      bgImagesUrl = require('@/assets/images/review@2x.png')
      break
    case OpenStatus.DONE:
      customStatus = 2
      bgImagesUrl = require('@/assets/images/review@2x.png')
      break
    case OpenStatus.FAIL: // 开户失败
      btnText = '开户失败'
      btnTips = '开户审核不通过，请<a>查看驳回原因</a>'
      bgImagesUrl = require('@/assets/images/reviewfail@2x.png')
      break
    case OpenStatus.OPEN_REJECT: // 审核驳回
      btnText = '重新填写资料'
      routerName = RouterName.ID_TYPE
      btnTips = `开户审核不通过，请<a href="/open-account/reason?type=${accountType}">查看驳回原因</a>`
      bgImagesUrl = require('@/assets/images/reviewfail@2x.png')
      break
    case OpenStatus.FAIL_BLACK: // 审核驳回并拉入黑名单
      btnText = '开户失败'
      btnTips = `开户失败，请<a href="/open-account/reason?type=${accountType}">查看驳回原因</a>`
      bgImagesUrl = require('@/assets/images/openfail@2x.png')
      break
    case OpenStatus.SUPPLEMENT:
      btnText = '上传转账凭证'
      btnTips = '已完成90%，请继续完善资料'
      routerName = RouterName.TRANSFER_STEP
      customStatus = OpenStatus.SUPPLEMENT
      bgImagesUrl = require('@/assets/images/continue@2x.png')
      break
    default:
      // eslint-disable-next-line no-case-declarations
      const openCommon = accountType === FormType.OPEN_IMMIGRANT_ACCOUNT ? btnInfo.draftsImmigrantAccount : btnInfo.draftsAccount
      // eslint-disable-next-line no-case-declarations
      const name = stepList[openCommon.step]
        ? stepList[openCommon.step]
        : RouterName.ID_TYPE
      if (openCommon.openStatus === 0) {
        btnText = '继续开户'
        routerName = name
        btnTips = openCommon.remark
        bgImagesUrl = require('@/assets/images/continue@2x.png')
      } else if (openCommon.openStatus === 1) {
        btnText = '身份核实'
        routerName = name
        btnTips = openCommon.remark
        bgImagesUrl = require('@/assets/images/continue@2x.png')
      } else {
        btnText = '立即开户'
        bgImagesUrl = require('@/assets/images/quick@2x.png')
        routerName = name
      }
      break
  }
  if (accountType === FormType.OPEN_IMMIGRANT_ACCOUNT) {
    btnInfo.immigrantBtnInfo.btnText = btnText
    btnInfo.immigrantBtnInfo.btnTips = btnTips
    btnInfo.immigrantBtnInfo.customStatus = customStatus
    btnInfo.immigrantBtnInfo.bgImagesUrl = bgImagesUrl
    btnInfo.immigrantBtnInfo.iconImagesUrl = require('@/assets/images/icons/投资移民开户.svg')
    btnInfo.immigrantBtnInfo.routerName = routerName
  } else {
    btnInfo.accountBtnInfo.btnText = btnText
    btnInfo.accountBtnInfo.btnTips = btnTips
    btnInfo.accountBtnInfo.customStatus = customStatus
    btnInfo.accountBtnInfo.bgImagesUrl = bgImagesUrl
    btnInfo.accountBtnInfo.iconImagesUrl = require('@/assets/images/icons/普通开户.svg')
    btnInfo.accountBtnInfo.routerName = routerName
  }
}

onResult((res) => {
  const { allFormTypeDrafts, customerOpenStatus, immigrantCustomerOpenStatus } = res.data
  if (allFormTypeDrafts.ok) {
    btnInfo.draftsAccount = JSON.parse(allFormTypeDrafts.data
      .find((v: { formType: string }) => v.formType === FormType.OPEN_ACCOUNT)?.content)
    btnInfo.draftsImmigrantAccount = JSON.parse(allFormTypeDrafts.data
      .find((v: { formType: string }) => v.formType === FormType.OPEN_IMMIGRANT_ACCOUNT)?.content)
  }
  if (customerOpenStatus.ok) {
    fromartDoc(customerOpenStatus.data.applicationStatus, FormType.OPEN_ACCOUNT)
  }
  if (immigrantCustomerOpenStatus.ok) {
    fromartDoc(immigrantCustomerOpenStatus.data.applicationStatus, FormType.OPEN_IMMIGRANT_ACCOUNT)
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "wrap",
    style: _normalizeStyle({ backgroundImage: 'url(' + imgUrl.value + ')' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(OpenAccount, {
        data: btnInfo.immigrantBtnInfo,
        type: _unref(FormType).OPEN_IMMIGRANT_ACCOUNT
      }, null, 8, ["data", "type"]),
      _createVNode(OpenAccount, {
        data: btnInfo.accountBtnInfo,
        type: _unref(FormType).OPEN_ACCOUNT
      }, null, 8, ["data", "type"])
    ])
  ], 4))
}
}

})